export type EnvName = "local" | "staging" | "production" | "development";
export function getEnvName(): EnvName {
  return process.env.REACT_APP_ENV_NAME as EnvName;
}
